import { useEffect, useState } from "react";
import { getUserName } from "../../_helpers/token";
import { Link, useLocation, useHistory } from "react-router-dom";
import logo from "../../_assets/MZGK_Boleslawiec.png";
import AnimateHeight from "react-animate-height";

const EkoBillingHeader = () => {
  const history = useHistory();
  const [height, setHeight] = useState<number>();
  const path = useLocation().pathname;
  const [userLogged, setUserLogged] = useState<boolean>();

  useEffect(() => {
    if (path.indexOf("Reset") >= 1 || path === '/login') {
      setHeight(80);
      setUserLogged(false);
    } else {
      setHeight(40);
      setUserLogged(true);
    }
  }, [path]);


  return (
    <>
      <div className="headerWrap">
        <header id="header" className="container">
          <div className="row">
            <div className="col-4 d-flex justify-content-start">
              <div className="middleText">
                {userLogged ? `Witaj, ` : null}{" "}
                <span className="userName">{getUserName()}</span>
              </div>
            </div>
            <div className="col-4 d-flex justify-content-center" onClick={() => history.push("/")}>
              <AnimateHeight
                id="siteLogo"
                className="siteLogo"
                duration={500}
                height={height}

                style={{ backgroundImage: `url(${logo})` }}
              >
                <></>
              </AnimateHeight>
            </div>
            <div className="col-4 d-flex justify-content-end">
              {userLogged ? (
                <Link to="/Logout" className="nav-link mainNavItem  ">
                  Wyloguj
                </Link>
              ) : null}
            </div>
          </div>
        </header>
      </div>
    </>
  );
};

export { EkoBillingHeader };
